<template>
    <div>
        <v-cookie></v-cookie>
        <div class="place">
            <span>位置：</span>
            <ul class="placeul">
                <li><a href="#">首页</a></li>
                <li><a href="#">账户设置</a></li>
                <li><a href="invoicelog">开票记录</a></li>
            </ul>
        </div>
        <div class="formbody">
            <div class="formtitle"><span>开票记录</span></div>
            <div id="usual1" class="usual"> 
                <div id="tab1" class="tabson">                
                    <table class="tablelist">
                        <thead>
                            <tr>								
                                <th style="width:10%">发票抬头</th>
                                <th style="width:10%">发票金额</th>
                                <th style="width:10%">税号</th>
                                <th style="width:10%">收件人</th>
                                <th style="width:10%">备注</th>
                                <th style="width:10%">申请时间</th>
                                <th style="width:10%">开票时间</th>
                                <th style="width:10%">状态</th>
                                <th style="width:10%">操作</th>
                                <!-- <th>操作</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in list" :class="{odd:index%2!=0}">
                                <td style="width:10%">
                                    {{item.lookedup}}
                                </td>
                                <td style="width:10%">
                                    {{item.money}}
                                </td>
                                <td style="width:10%">
                                    {{item.taxpayerID}}
                                </td>
                                <td style="width:10%">
                                    {{item.recipient}}
                                </td>
                                <td style="width:10%;color: red;">
                                    {{item.note}}
                                </td>
                                <td style="width:10%">
                                    {{item.createtime}}
                                </td>
                                <td style="width:10%">
                                    {{item.createdDate}}
                                </td>
                                <td style="width:10%">
                                    <template v-if="item.status == 0">
                                        开票中
                                    </template>
                                    <template v-else>
                                        已开票
                                    </template>
                                </td>
                                <td style="width:10%">
                                    <li @click="openInfo(index)">查看</li>
                                </td>
                                <!-- <td>
                                    <el-button type="text" @click="lookinvoice(item.id, item.money)">查看</el-button>
                                </td> -->
                            </tr>     
                        </tbody>
                    </table>
                    <div class="pagin">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="pageIndex"
                            :page-sizes="[pageSize]"
                            :page-size="50"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                        </el-pagination>
                    </div>

                    <!-- 查询等待 -->
                    <div style="position: fixed; width:100%; height:100%; z-index:9999; background:rgb(51, 51, 51); opacity: 0.3; 
                        top: 0; left: 0;display: block;" v-show="loadingShow"></div>
                    <div style="position:fixed; left: 50%; top:50%; transform: translate3d(-50%, -50%, 0px); -ms-transform: translate3d(-50%, -50%, 0px);
                        -webkit-transform: translate3d(-50%, -50%, 0px); z-index: 10000;" v-show="loadingShow">
                        <i class="el-icon-loading" style="font-size: 40px;color:coral;"></i>
                        <div style="margin-left:-20px;color:coral;"><span style="font-size: 13px;">查询中,请稍后...</span></div>
                    </div>
                    
                </div>
            </div>
            <div class="tip" style="height:400px;">
    	        <div class="tiptop"><span>开票信息</span><a></a></div>
                <ul class="tipinfo">
                    <li class="h32">发票抬头：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.lookedup}}</li>
                    <li class="h32">发票金额：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.money}}</li>
                    <li class="h32">发票类型：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.invoicetype}}</li>
                    <li class="h32">纳税人识别号：{{invoiceInfo.taxpayerID}}</li>
                    <li class="h32">银行账号：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.cardId}}</li>
                    <li class="h32">开户行：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.bank}}</li>
                    <li class="h32">注册地址：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.corpAddr}}</li>
                    <li class="h32">企业电话：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.corpTel}}</li>
                    <li class="h32">收件人：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.recipient}}</li>
                    <li class="h32">邮编：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.code}}</li>
                    <li class="h32">邮寄地址：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.address}}</li>
                    <li class="h32">邮寄方式：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.post}}</li>
                    <li class="h32">手机：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.mobile}}</li>
                    <li class="h32">申请时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.createtime}}</li>
                    <li class="h32">开票时间：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.sendtime}}</li>
                    <li class="h32">状态：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<template v-if="invoiceInfo.status == 1">已开票</template><template v-else>未开票</template></li>
                    <li class="h32">留言：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.discription}}</li>
                    <li class="h32">备注：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{invoiceInfo.note}}</li>
                </ul> 
            </div>
        </div>
    </div>
</template>
<script>
import cookie from '@/components/cookie.vue'
import '@/assets/js/jquery.js'
export default {
    data() {
        return{
            list: [],
            pageIndex: 0,
            pageSize: 50,
            totalCount: 0,
            isShow: true,
            showinvoice: '',
            twoyear: '',
            loadingShow: true,
            invoiceInfo:{},
        }
    },
    components : {
        'v-cookie' : cookie,
    },
    mounted() {
        this.pageChange(1);
    },
    methods: {
        handleSizeChange(val) {
            this.pageChange(val)
        },
        handleCurrentChange(val) {
            this.pageChange(val)
        },
        pageChange(pageIndex) {
            this.loadingShow = true;
            var that = this
            let param = {'pageIndex': pageIndex, 'pageSize': this.pageSize}
            this.$ajax({
                method: 'post',
                url: this.GLOBAL.serverSrc + "/invoice/invoicelog.json",
                data: param,
                headers: {
                    'Content-Type': 'application/json; charset=UTF-8',
                    'token' : this.GLOBAL.token
                }
            }).then(function(res) {
                if(res.data.code == '0000000')
                {
                    that.twoyear = that.getTwoYearAgo();
                    that.list = res.data.invoicelogList;
                    that.list.forEach(element => {
                        if(element.note != undefined && element.note != null && element.note.trim().length> 0)
                        {
                            element.note = element.note.replace(new RegExp( 'renmg:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'chenfy:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'qiuzm33:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'zhaodx30:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'xujj:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'ruanjt:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'kefu2:' , "g" ),"");
                            element.note = element.note.replace(new RegExp( 'panyy28:' , "g" ),"");
                        }
                    });
                    that.pageIndex = res.data.page.pageIndex;
                    that.pageSize = res.data.page.pageSize;
                    that.totalCount = res.data.page.totalCount;
                    that.loadingShow = false;
                }
                else
                {
                    alert(res.data.msg)
                }
            })
        },
        //获得两年前的时间
        getTwoYearAgo() {
            var date = new Date();
            var seperator1 = "-";
            var year = date.getFullYear() - 2;
            var month = date.getMonth() + 1;
            var strDate = date.getDate();
            var hour = date.getHours();
            var minutes = date.getMinutes();
            var second = date.getSeconds();
            if(second >= 0 && second < 10)
            {
                second = "0" + second;
            }
            if (month >= 1 && month <= 9) {
                month = "0" + month;
            }
            if (strDate >= 0 && strDate <= 9) {
                strDate = "0" + strDate;
            }
            var currentdate = year + seperator1 + month + seperator1 + strDate + " " + hour + ":" + minutes + ":" + second;
            return currentdate;
        },
        openInfo(index){
            //(index);
            this.invoiceInfo = this.list[index];
            //console.log(JSON.stringify(this.invoiceInfo));
            $(".tip").fadeIn(200);
            $(".tiptop a").click(function(){
                $(".tip").fadeOut(200);
            })
        },
        closeInfo(){
            $(".tip").fadeOut(200);
        }
        // lookinvoice(id, money) {

        // }
    }
}
</script>>



// WEBPACK FOOTER //
// src/components/invoice/invoicelog.vue